import { makeStyles } from "@material-ui/core";

export const useWorkOrderStyles = makeStyles((theme) => ({
    row: {
        marginLeft: "8px",
        marginBottom: "10px",
    },
    rowFull: {
        width: "100%",
    },
}));
